// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { TARIFAS_API } from "../views/MainLayout/components/shared/services/tarifas";
import { makeSetReducer } from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const tarifasFullfilledReducer = makeSetReducer(['tarifas/fullfilled']);

export const fetchTarifas = () => async dispatch => {
     dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await TARIFAS_API.get()
        const data = await response.data;
        dispatch({ type: 'tarifas/fullfilled', payload: data })
        const readOnly = JSON.parse(localStorage.getItem('read_only'));
        readOnly.tarifas = data;
        localStorage.setItem('read_only', JSON.stringify(readOnly));
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}